import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ImageBackground from '../UI/ImageBackground.jsx'
import Description from '../UI/Description.jsx';
import { useState } from 'react';




const Accueil = ({
    interaction,
    changerPage,
    isImageBlur = true,
    textBTNParticiper= 'Participer',
}) => {
    const [asAlreadyVoted, setAsAlreadyVoted] = useState('');
    const [showAlreadyVoted, setShowAlreadyVoted] = useState(false);

    const verifyAsAlreadiVoted = () => {
        if (interaction.limit_1_vote && interaction.asAlreadyVoted) {
            setAsAlreadyVoted('as-already-voted');
            setShowAlreadyVoted(true);
            setTimeout(() => {
                setAsAlreadyVoted('');
                setShowAlreadyVoted(false);
            }, 3000);
            return;
        }
        changerPage();
    }

    return (
        <div className="accueil">
            {showAlreadyVoted &&
                <>
                    <div className={asAlreadyVoted}  >Désolé, <br />
                        Vous êtes limité à une <br />
                        participation pour cette <br />
                        événement
                    </div>
                </>
            }
            <Row className="home-background text-center">
                <Col>
                    <ImageBackground interaction={interaction} isImageBlur={isImageBlur} />
                </Col>
            </Row>
            <Row className="custom-instructions">
                <Col>
                    <Description interaction={interaction} />
                </Col>
            </Row>
            <Row className="custom-commandes">
                <Col>
                    <Button onClick={verifyAsAlreadiVoted}>{textBTNParticiper}</Button>
                </Col>
            </Row>
        </div>
    );
}

export default Accueil;